import { useEffect } from "react";
import { onPlatformPush } from "../../services/pushNotifications";
import { showToast } from "../../utils/toast";

/**
 * In-app toast when a push arrives while the tab is focused.
 * OS notifications are shown by the service worker (foreground + background).
 */
export default function PushNotificationToast() {
  useEffect(() => {
    function onOsBlocked(event) {
      const hint = event?.detail?.hint;
      if (hint) showToast.error(hint);
    }
    window.addEventListener("nema:os-notification-blocked", onOsBlocked);
    return () => window.removeEventListener("nema:os-notification-blocked", onOsBlocked);
  }, []);

  useEffect(() => {
    return onPlatformPush((detail) => {
      if (typeof document !== "undefined" && document.visibilityState !== "visible") {
        return;
      }
      const type = String(detail?.type || "").toUpperCase();
      if (type === "PUSH_TEST") {
        return;
      }
      const title = detail?.title || "New notification";
      const body = detail?.body || "";
      if (body) {
        showToast.info(`${title}: ${body}`);
      } else {
        showToast.info(title);
      }
    });
  }, []);

  return null;
}
